import { Directive, ElementRef, HostListener, inject, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appSanitizeInput]',
  standalone: false
})
export class SanitizeInputDirective {

  private el = inject(ElementRef);
  private control = inject(NgControl, { optional: true });

  @Input() appSanitizeInput:
    | 'safe'
    | 'strict'
    | 'name'
    | 'distance'
    | 'mobile'
    | 'license'
    | 'search'
    | 'email'
    | 'username'
    | 'address'
    | 'password'
    | 'integer'
    | 'complaintNumber'
    | 'token'
    | 'tankerType'
    | 'coordinates' 
    | 'designation'
    | 'alphanumeric'
    | 'newDesignation'
    | 'textNumber'
    | 'textOnly'
    | 'docket' = 'safe';

  @HostListener('input', ['$event'])
  onInput(event: any) {

    let value = event.target.value || '';

    switch (this.appSanitizeInput) {

      /* ================= NAME ================= */
      case 'name':
        value = value.replace(/[^A-Za-z\s]/g, '');
        value = value.trimStart();
        value = value.slice(0, 50);
        break;

      case 'alphanumeric':
  value = value.replace(/[^A-Za-z0-9-]/g, '');
  value = value.slice(0, 100);
  break;

      case 'complaintNumber':
        value = value.replace(/\D/g, '');
        value = value.slice(0, 50);          
        break;

      case 'token':
        value = value.replace(/[^0-9]/g, '');
        value = value.slice(0, 11);
        break;

      /* ================= MOBILE ================= */
      case 'mobile':
        value = value.replace(/\D/g, '').slice(0, 10);
        break;

      /* ================= LICENSE ================= */
      case 'license':
        value = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 17);
        break;

      /* ================= DISTANCE ================= */
      case 'distance':
        value = value.replace(/[^0-9.\sA-Za-z]/g, '');

        const parts = value.split('.');
        if (parts.length > 2) {
          value = parts[0] + '.' + parts.slice(1).join('');
        }

        value = value.trimStart();
        value = value.slice(0, 15);
        break;

      /* ================= STRICT ================= */
      case 'strict':
        value = value.replace(/[^a-zA-Z0-9\s]/g, '');
        break;

      /* ================= SEARCH ================= */
      case 'search':
        value = value.replace(/[^A-Za-z\s]/g, '');
        value = value.trimStart();
        value = value.slice(0, 50);
        break;
      /* ================= EMAIL ================= */
      case 'email':
        value = value
          .replace(/[^a-zA-Z0-9@._-]/g, '')
          .replace(/\s/g, '')
          .toLowerCase();
        break;

      case 'integer':
        value = value.replace(/[^0-9.]/g, '');

        const part = value.split('.');
        if (part.length > 2) {
          value = part[0] + '.' + part.slice(1).join('');
        }

        break;

      case 'coordinates':

        // Allow only digits, dot and minus
        value = value.replace(/[^0-9.-]/g, '');

        // Only one minus sign and only at the beginning
        value = value.replace(/(?!^)-/g, '');

        // Only one decimal point
        const part_C = value.split('.');
        if (part_C.length > 2) {
          value = part_C[0] + '.' + part_C.slice(1).join('');
        }

        break;


      /* ================= USERNAME (MOBILE OR EMAIL) ================= */
      case 'username':

        // remove spaces completely
        value = value.replace(/\s+/g, '');

        // remove dangerous chars
        value = value.replace(/[<>`"'%;()&]/g, '');

        const isNumeric = /^[0-9]*$/.test(value);

        if (isNumeric) {
          value = value.replace(/\D/g, '').slice(0, 10);
        } else {
          
          value = value
            .replace(/[^A-Za-z0-9@._+-]/g, '')
            .toLowerCase();
        }

        break;

      case 'address':
        value = value.replace(/[^A-Za-z0-9\s,./-]/g, '');
        value = value.trimStart();
        value = value.slice(0, 150);
        break;

        case 'tankerType':
  value = value.replace(/<[^>]*>/g, '');
  value = value.replace(/javascript:/gi, '');
  value = value.replace(/on\w+=/gi, '');
  value = value.replace(/[^A-Za-z0-9\s]/g, '');
  value = value.replace(/\s{2,}/g, ' ');
  value = value.trimStart();
  value = value.slice(0, 20);

  break;

  case 'designation':
  value = value.replace(/[^A-Za-z\s()\/&.-]/g, '');
  value = value.trimStart();
  value = value.slice(0, 50);
  break;


case 'newDesignation':
  value = value.replace(/[^A-Za-z\s()&./-]/g, '');
  value = value.trimStart();
  value = value.slice(0, 50);
  break;
      /* ================= PASSWORD ================= */
      case 'password':

        // remove all spaces
        value = value.replace(/\s+/g, '');

        // remove only dangerous chars (keep valid special chars)
        value = value.replace(/[<>`"'\\]/g, '');

        // limit length
        value = value.slice(0, 20);

        const passwordPattern =
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

        if (this.control?.control) {
          if (!passwordPattern.test(value)) {
            this.control.control.setErrors({
              ...(this.control.control.errors || {}),
              passwordInvalid: true
            });
          } else {
            const errors = this.control.control.errors;
            if (errors) {
              delete errors['passwordInvalid'];
              if (Object.keys(errors).length === 0) {
                this.control.control.setErrors(null);
              } else {
                this.control.control.setErrors(errors);
              }
            }
          }
        }

        break;
        case 'docket':
  value = value.replace(/[^A-Za-z0-9\s-]/g, '');
  value = value.trimStart();
  value = value.replace(/\s{2,}/g, ' ');
  value = value.replace(/-{2,}/g, '-');
  value = value.replace(/\s*-\s*/g, '-');

  // Limit length
  value = value.slice(0, 100);

  break;

 case 'textNumber':
  value = value.replace(/[^A-Za-z0-9\s-]/g, '');
  value = value.trimStart();
  value = value.slice(0, 100);

  break;

  case 'textOnly':
  value = value.replace(/[^A-Za-z\s]/g, '');
  value = value.trimStart();
  value = value.slice(0, 100);

  break;

      /* ================= SAFE ================= */
      case 'safe':
      default:
        value = value
          .replace(/<.*?>/g, '')
          .replace(/javascript:/gi, '')
          .replace(/on\w+=/gi, '')
          .replace(/[<>`"'%;()&]/g, '');
    }

    /* ================= APPLY VALUE ================= */
    this.el.nativeElement.value = value;

    if (this.control?.control) {
      //this.control.control.setValue(value);
      this.control.control.setValue(value, {
       emitEvent: false
      });
      this.control.control.markAsDirty();
      this.control.control.updateValueAndValidity();
    }
  }
}